__turbopack_context__.v({
  "blok-big-title": "Switch-module__egemaW__blok-big-title",
  "blok-subtitle": "Switch-module__egemaW__blok-subtitle",
  "blok-title": "Switch-module__egemaW__blok-title",
  "content-switch": "Switch-module__egemaW__content-switch",
  "options": "Switch-module__egemaW__options",
  "toggle": "Switch-module__egemaW__toggle",
});
